module.exports = __webpack_public_path__ + "img/Company_Icon.841dfc48.svg";